import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionsContext';

/**
 * Composant de protection de route basé sur les permissions.
 * Vérifie que la permission "display" est activée pour la ressource.
 * Si non, redirige vers le dashboard.
 */
const PermissionRoute = ({ children, resource, adminOnly = false }) => {
  const { permissions, loading } = usePermissions();

  // Attendre le chargement des permissions
  if (loading) {
    return (
      <div className="page-loading">
        <div className="loader"></div>
        <span>Chargement...</span>
      </div>
    );
  }

  // Si adminOnly, vérifier via le contexte Auth (géré par AdminRoute)
  if (adminOnly) {
    return children;
  }

  // Vérifier si la permission "display" est activée pour cette ressource
  if (!permissions || typeof permissions !== 'object') {
    return <Navigate to="/" replace />;
  }

  const resourcePerms = permissions[resource];
  if (!resourcePerms || typeof resourcePerms !== 'object') {
    return <Navigate to="/" replace />;
  }

  // "display" pilote le menu, mais une route reste consultable si "view" est autorisé
  // (ex: accès depuis une notification ou depuis le dashboard).
  if (resourcePerms.display !== true && resourcePerms.view !== true) {
    return <Navigate to="/" replace />;
  }

  // Sinon, afficher le composant enfant
  return children;
};

export default PermissionRoute;
